<script setup>
import { computed, inject } from "vue";
import { useI18n } from "vue-i18n";

const route = inject("route");
const { t } = useI18n();
</script>
<template>
  <div class="bg-primary">
    <div class="section-container">
      <div class="bg-white p-12 rounded-lg shadow-lg">
        <h2
          class="text-4xl md:text-5xl"
        >{{ $t('Dienstverlening binnen de Gehandicaptenzorg en GGZ') }}</h2>
        <div class="mt-10 grid md:grid-cols-3 gap-8">
          <div class="bg-[#d3f8f2] p-6 rounded-lg shadow-md text-left">
            <h3 class="text-xl font-semibold mb-3">{{ $t('Individuele Begeleiding') }}</h3>
            <p
              class="text-lg"
            >{{ $t('Zorgblik biedt ervaren en gecertificeerde begeleiders, gespecialiseerd in het ondersteunen van mensen met een beperking of psychische kwetsbaarheid.') }}</p>
            <p
              class="text-lg"
            >{{ $t('Onze professionals bieden begeleiding in het dagelijks leven, stimuleren zelfredzaamheid en ondersteunen persoonlijke ontwikkeling') }}</p>
          </div>
          <div class="bg-[#d3f8f2] p-6 rounded-lg shadow-md text-left">
            <h3 class="text-xl font-semibold mb-3">{{ $t('Werving en Selectie') }}</h3>
            <p
              class="text-lg"
            >{{ $t('We helpen zorgorganisaties met het vinden van gekwalificeerd personeel, van verpleegkundigen tot begeleiders. We screenen kandidaten grondig en zorgen voor een soepele werving en selectieprocedure.') }}</p>
          </div>
          <div class="bg-[#d3f8f2] p-6 rounded-lg shadow-md text-left">
            <h3 class="text-xl font-semibold mb-3">{{ $t('Opleidingen en Trainingen') }}</h3>
            <p
              class="text-lg"
            >{{ $t('ZorgBlik biedt diverse opleidingen en trainingen voor professionals in de zorg.') }}</p>
            <p
              class="text-lg"
            >{{ $t('Deze zijn gericht op het up-to-date houden van kennis en vaardigheden, én op het bevorderen van professionele ontwikkeling.') }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>